<template>
  <div class="mobile-container">
    <div class="pb-05">
      <v-alert
        dense
        text
        type="warning"
        icon="mdi-shield-alert"
        class="caption-regular pr-4 py-3 mb-2"
        rounded="0"
      >
        مشخصات بار، ناوگان و کرایه حمل بار خود را تعیین کنید.
      </v-alert>
    </div>

    <keep-alive>
      <LoadDrafts
        :load="load"
        :form-validation="validate"
        :insurance-options="insuranceOptions"
        :payment-options="paymentOptions"
        @handle-package-dialog="handlePackageDialog"
        @handle-bar-dialog="handleBarDialog"
        @handle-vehicle-dialog="handleVehicleDialog"
        @switch-insurance="switchInsuranceOption"
        @switch-payment="switchPaymentOption"
        @handle-update-load-value="UpdateLoadValue"
      />
    </keep-alive>

    <v-form v-model="validate">
      <v-card class="mt-2 pt-05 pb-4 ev-0" rounded="0">
        <v-card-title class="high-emp subtitle1-regular pt-3 pb-05 px-4"
          >مشخصات بار و ناوگان:</v-card-title
        >
        <div class="row mx-0">
          <div class="col-12 px-4 pt-4 pt-md-3 pb-0">
            <v-text-field
              @focus="barDialog = true"
              :value="selectedBar"
              dense
              outlined
              required
              height="50"
              color="var(--logistic)"
              type="text"
              label="نوع بار"
              clearable
              append-icon="mdi-chevron-left"
              :rules="[$utils.validators.required]"
            ></v-text-field>
          </div>

          <div class="col-12 px-4 pb-0">
            <v-text-field
              @focus="packageDialog = true"
              :value="selectedPackage"
              :rules="[$utils.validators.required]"
              dense
              outlined
              clearable
              required
              height="50"
              color="var(--logistic)"
              type="text"
              label="نوع بسته بندی"
              append-icon="mdi-chevron-left"
            ></v-text-field>
          </div>

          <div class="col-12 px-4 pb-0">
            <v-text-field
              dense
              outlined
              required
              height="50"
              color="var(--logistic)"
              label="تناژ کل بار"
              clearable
              v-model.number="load.tonnage"
              type="number"
              :rules="[
                $utils.validators.onlyNumbers,
                $utils.validators.required,
                $utils.validators.maxNumber(load.tonnage, 99),
              ]"
            ></v-text-field>
          </div>

          <div class="col-12 px-4 pb-0">
            <v-select
              @focus="vehicleDialog = true"
              :items="poshSelectedVehicle"
              v-model="poshSelectedVehicle"
              item-text="v_name"
              class="min-height-50"
              multiple
              readonly
              dense
              outlined
              required
              color="var(--logistic)"
              type="text"
              label="نوع ماشین و باربر مورد نیاز"
              :rules="[$utils.validators.required]"
              append-icon="mdi-chevron-left"
            >
              <template v-slot:selection="data">
                <div>
                  <v-chip
                    class="ma-2 active-option"
                    text-color="var(--logistic)"
                    >{{ data.item.v_name }}
                    <v-avatar right class="logistic-color white--text">
                      {{ data.item.v_amount }}
                    </v-avatar>
                  </v-chip>
                </div>
              </template>
            </v-select>
          </div>
        </div>
      </v-card>

      <v-card class="mt-3 pt-05 pb-1 ev-0" rounded="0">
        <v-card-title class="high-emp subtitle1-regular pt-3 pb-05 px-4"
          >اطلاعات بار:</v-card-title
        >

        <v-row class="mx-0 px-3 pt-1">
          <v-col cols="4" class="px-1 pb-0">
            <v-text-field
              dense
              outlined
              height="50"
              color="var(--logistic)"
              :rules="[
                $utils.validators.maxNumber(load.dimensions[0], 99),
                $utils.validators.onlyNumbers,
              ]"
              type="number"
              label="طول (اختیاری)"
              hint="عدد به متر"
              clearable
              v-model="load.dimensions[0]"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="px-1 pb-0">
            <v-text-field
              dense
              outlined
              height="50"
              color="var(--logistic)"
              type="number"
              label="عرض (اختیاری)"
              clearable
              hint="عدد به متر"
              :rules="[
                $utils.validators.maxNumber(load.dimensions[1], 99),
                $utils.validators.onlyNumbers,
              ]"
              v-model="load.dimensions[1]"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="px-1 pb-0">
            <v-text-field
              dense
              outlined
              height="50"
              color="var(--logistic)"
              type="number"
              label="ارتفاع (اختیاری)"
              hint="عدد به متر"
              clearable
              :rules="[
                $utils.validators.maxNumber(load.dimensions[2], 99),
                $utils.validators.onlyNumbers,
              ]"
              v-model="load.dimensions[2]"
            ></v-text-field>
          </v-col>
        </v-row>

        <keep-alive>
          <insurance :load="load" ref="insurance"></insurance>
        </keep-alive>

        <div class="col-12 px-4">
          <v-textarea
            dense
            outlined
            dir="rtl"
            height="50"
            color="var(--logistic)"
            type="text"
            label="توضیحات اضافه (اختیاری)"
            v-model="load.description"
          ></v-textarea>
        </div>
      </v-card>

      <v-card class="mt-3 pt-05 pb-1 ev-0" rounded="0">
        <v-card-title class="high-emp subtitle1-regular pt-3 pb-05 px-4"
          >اطلاعات کرایه حمل :</v-card-title
        >

        <div class="row mx-4 mt-4 rounded-sides border-grey">
          <div
            v-for="option of insuranceOptions"
            :key="option.id"
            class="pa-0 col id-option"
          >
            <div
              @click="switchInsuranceOption(option)"
              class="pa-3 border cursor-pointer"
              :class="option.active && 'active-option'"
              elevation="0"
            >
              <v-icon
                v-if="option.active"
                class="ml-2 logistic--text force-color"
                >mdi-check-circle</v-icon
              >
              <v-icon v-else class="ml-2 grey--text">mdi-circle-outline</v-icon>
              <small class="bold" v-text="option.name"></small>
            </div>
          </div>
        </div>

        <div class="col-12 px-4 mt-3">
          <v-text-field
            dense
            outlined
            required
            height="50"
            color="var(--logistic)"
            type="number"
            label="مبلغ کرایه"
            class="text-on-icon"
            append-icon="تومان"
            v-model.number="load.price"
            :rules="[$utils.validators.onlyMoney, $utils.validators.required]"
          ></v-text-field>
          <div v-if="load.price > 0" class="pr-4 -mt-1 caption-regular pb-2">
            {{ load.price && `${$utils.numberToLetter(load.price)} تومان` }}
          </div>
        </div>
      </v-card>

      <v-card class="mt-3 pb-2 py-1 ev-0" rounded="0">
        <v-card-title class="high-emp subtitle1-regular pt-3 pb-05 px-4"
          >روش پرداخت کرایه :</v-card-title
        >

        <div class="row px-4 mt-4">
          <div
            v-for="option of paymentOptions"
            :key="option.id"
            class="pb-3 pt-0 col-12"
          >
            <v-card
              @click="switchPaymentOption(option)"
              class="pa-3 border border-grey cursor-pointer body2-regular"
              :class="option.active && 'active-option'"
              elevation="0"
            >
              <v-icon
                class="ml-2"
                :class="
                  option.active
                    ? 'logistic--text force-color'
                    : 'grey--text text--lighten-1'
                "
                >{{
                  option.active ? "mdi-check-circle" : "mdi-circle-outline"
                }}</v-icon
              >
              <span v-text="option.name"></span>
            </v-card>
          </div>
        </div>
      </v-card>
    </v-form>

    <bar-select-list
      :visible="barDialog"
      @handle-bar-dialog="handleBarDialog"
    ></bar-select-list>

    <package-select-list
      :visible="packageDialog"
      :current-value="selectedPackage"
      @handle-package-dialog="handlePackageDialog"
    ></package-select-list>

    <vehicle-multi-select-list
      :visible="vehicleDialog"
      :current-value="selectedVehicle"
      @handle-vehicle-dialog="handleVehicleDialog"
    ></vehicle-multi-select-list>
  </div>
</template>

<script>
import VehicleMultiSelectList from "../VehicleMultiSelectList.vue";
import BarSelectList from "../BarSelectList";
import PackageSelectList from "../PackageSelectList.vue";
import insurance from "./components/Insurance.vue";
import LoadDrafts from "./components/LoadDrafts.vue";
export default {
  components: {
    VehicleMultiSelectList,
    insurance,
    BarSelectList,
    PackageSelectList,
    LoadDrafts,
  },
  props: {
    load: {
      type: Object,
      require: true,
    },
    permissions: {
      type: Array,
      require: true,
      default: [false, false, false, false],
    },
  },
  data() {
    return {
      validate: false,
      vehicleDialog: false,
      selectedVehicle: {
        barbar: null,
      },
      poshSelectedVehicle: [],
      barDialog: false,
      selectedBar: null,
      packageDialog: false,
      selectedPackage: null,
      insuranceOptions: [
        {
          name: "با احتساب بیمه",
          id: "1",
          active: true,
          value: true,
        },
        {
          name: "بدون احتساب بیمه",
          id: "2",
          active: false,
          value: false,
        },
      ],
      paymentOptions: [
        {
          name: "پرداخت توسط خودم ( آنلاین )",
          id: 1,
          active: true,
          value: true,
        },
        {
          name: "پرداخت در مقصد ( نقدی )",
          id: 2,
          active: false,
          value: false,
        },
      ],
    };
  },
  watch: {
    validate(val) {
      this.permissions.splice(2, 1, val);
    },
  },
  mounted() {
    this.paymentInit();
    this.insuranceInit();
  },
  methods: {
    switchInsuranceOption(op) {
      this.insuranceOptions.map((option) => (option.active = false));
      this.load.with_insurance = op.value;
      op.active = true;
    },
    switchPaymentOption(op) {
      this.paymentOptions.map((option) => (option.active = false));
      this.load.payed_in_origin = op.value;
      op.active = true;
    },
    UpdateLoadValue() {
      this.$refs.insurance.valueInit();
    },
    handleVehicleDialog(op, data) {
      if (op === "close") {
        this.vehicleDialog = false;
        if (!data) {
          this.resetVehicle();
          return;
        }
        this.selectedVehicle = data;
        let posh = [];
        data.barbar.map((item, i) => {
          if (!posh.some((e) => e.v_name === item.v_name)) {
            posh.push({
              v_name: item.v_name,
              v_amount: item.v_amount,
            });
          }
        });

        this.poshSelectedVehicle = posh;
        this.load.vehicle = data.barbar;
      }
    },
    handleBarDialog(op, data) {
      if (op === "close") {
        this.barDialog = false;
        if (!data) {
          this.resetBar();
          return;
        }
        this.selectedBar = data;
        this.load.load_type = data;
      }
    },
    handlePackageDialog(op, data) {
      if (op === "close") {
        this.packageDialog = false;
        if (!data) {
          this.resetPackage();
          return;
        }
        this.selectedPackage = data;
        this.load.package_type = data;
      }
    },
    resetVehicle() {
      this.selectedVehicle = {
        barbar: null,
      };
      this.poshSelectedVehicle = [];
      this.load.vehicle = null;
    },
    resetPackage() {
      this.selectedPackage = null;
      this.load.package_type = null;
    },
    resetBar() {
      this.selectedBar = null;
      this.load.load_type = null;
    },
    paymentInit() {
      this.load.payed_in_origin = true;
    },
    insuranceInit() {
      this.load.with_insurance = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.border-grey {
  border: 1px solid #b8b8b8;
  border-radius: 4px !important;
}
.rounded-sides .id-option {
  &:first-child .border {
    border-radius: 0 4px 4px 0 !important;
  }
  &:last-child .border {
    border-radius: 4px 0 0 4px !important;
  }
}
</style>
<style scoped>
.min-height-50 >>> .v-select__slot {
  min-height: 50px !important;
}
</style>